import { createRoutine } from 'redux-saga-routines';

export const getTokenPricesRoutine = createRoutine('prices/GET_TOKEN_PRICES');